import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface ISelectedChip {
  label: string;
  names: string[];
}

@Component({
  selector: 'app-selected-chips',
  templateUrl: './selected-chips.component.html',
  styleUrls: ['./selected-chips.component.scss']
})
export class SelectedChipsComponent {
  @Input() items: ISelectedChip[] = [];
  @Input() title = 'Selected:';
  @Output() remove = new EventEmitter<string[]>();
}
